import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import injectSheet from 'react-jss';

import { BRAND_NAME } from '~/common/constants/brand';

import styles from './LoginPageContainer.styles';

function LoginPageContainer({ classes, children, title }) {
  const intl = useIntl();

  return (
    <div className={classes.container}>
      <div className={classes.logoContainer}>
        <a
          href="/"
          title={intl.formatMessage(
            {
              id: 'LoginPageContainer.logoLinkTitle',
              defaultMessage: '{brandName} login page',
              description: 'Title for logo link on login page',
            },
            { brandName: BRAND_NAME },
          )}
        >
          <img
            src="/evisort.png"
            alt={BRAND_NAME}
            title={BRAND_NAME}
            className={classes.logoImg}
          />
        </a>
      </div>
      <div className={classes.contentContainer}>
        <div className={classes.title} role="heading" aria-level="1">
          {title}
        </div>
        {children}
      </div>
    </div>
  );
}

LoginPageContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(LoginPageContainer);
